import { Gamecloud } from "../../gamecloud";
import { Confirm } from "../../../confirm/confirm";

class Regionfixer extends Gamecloud {
  private _chunkFixBtn : string = '#fixChunks';
  
  public constructor() {
    super();
    this._registerEvents();
  }
  
  /**
   * registering events for the click stuff
   * @private
   */
  private _registerEvents() {
    if($(this._chunkFixBtn).length) {
      $(this._chunkFixBtn).on('click', function(event : JQuery.TriggeredEvent) {
        new Confirm('Warning: Your server will be stopped to perform this action is necessary, do you want to do that?',
          () => {
            $('#chunkFixForm').trigger('submit');
          }, () => {});
        
        event.preventDefault();
      });
    }
  }
}

export function initRegionfixer() : void {
  new Regionfixer();
}
